import React from "react";
import { Route, Switch } from "react-router-dom";
// No logged
import App from "../App";
import LoginPage from "../screens/LoginScreen";
import ResetPasswordPage from "../screens/ResetPasswordPage";
// ACCOUNT
import Settings from "../screens/settings/Show";
// SIDEBAR
import Sidebar from "Components/sidebar/Sidebar";
// EMAIL ACCOUNTS
import EmailAccount from "../screens/emailAccounts/Show";
import EmailAccountSettings from "../screens/emailAccounts/Settings";
// ETLIVE
import ETLive from "../screens/etlive/List";
// OTHERS
import ServerMissing from "Components/ServerMissing";
import NotFound from "Components/NotFound";
// AUDITS
import AuditsList from "../screens/audits/List";
import qs from "query-string";

export default (props) => (
  <div>
    <Route exact path="/login" component={LoginPage} />
    <Route exact path="/users/:userCode/reset_password" component={ResetPasswordPage} />
    <Route exact path="/manteinance" component={ServerMissing} />

    <Route
      render={(routerProps) => {
        const p = { ...props, ...routerProps };
        // add location.query to the props
        p.location.query = qs.parse(p.location.search);

        return (
          <Sidebar {...p}>
            <Switch>
              <Route exact path="/account" component={Settings} />
              <Route exact path="/audits" component={AuditsList} />
              <Route exact path="/tracemail" component={ETLive} />

              <Route
                path="/"
                render={(props) => {
                  const subProps = { ...p, ...props };
                  return (
                    <EmailAccount
                      {...subProps}
                      render={(componentProps) => {
                        return (
                          <>
                            <Route
                              exact
                              path="/"
                              render={() => <EmailAccountSettings {...{ ...p, ...componentProps }} />}
                            />
                            <Route
                              exact
                              path="/home"
                              render={() => <EmailAccountSettings {...{ ...p, ...componentProps }} />}
                            />
                          </>
                        );
                      }}
                    />
                  );
                }}
              />
              <Route exact path="*" component={NotFound} />
            </Switch>
          </Sidebar>
        );
      }}
    />
  </div>
);
